var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    staticClass: "left",
    attrs: {
      span: 8
    }
  }, [_c("a-form-model", {
    ref: "warterMarkRef",
    attrs: {
      model: _vm.form,
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.watermarkSwitch")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.watermarkSwitch,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "watermarkSwitch", $$v);
      },
      expression: "form.watermarkSwitch"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("deploy.close")) + " ")])], 1)], 1), _vm.form.watermarkType == 1 ? _c("div", [_c("a-form-model-item", [_c("span", {
    staticClass: "redStar",
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t("picWatermark.watermarkImg")))]), _c("a-upload", {
    staticClass: "avatar-uploader",
    staticStyle: {
      width: "200px",
      height: "200px"
    },
    attrs: {
      name: "file",
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      data: _vm.updateData,
      "before-upload": _vm.beforeUpload
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.uploadImg && !_vm.uploading ? _c("img", {
    staticStyle: {
      width: "200px",
      height: "200px"
    },
    attrs: {
      src: _vm.uploadImg,
      alt: "#"
    }
  }) : _c("a-icon", {
    staticStyle: {
      "font-size": "24px"
    },
    attrs: {
      type: _vm.uploading ? "loading" : "plus"
    }
  })], 1), !_vm.uploadImg ? _c("div", {
    staticStyle: {
      color: "red",
      "margin-top": "25px"
    }
  }, [_vm._v(_vm._s(_vm.$t("picWatermark.suggestion")))]) : _vm._e()], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.position")
    }
  }, [_c("a-select", {
    attrs: {
      disabled: !_vm.uploadImg
    },
    on: {
      change: _vm.changePosition
    },
    model: {
      value: _vm.form.position,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "position", $$v);
      },
      expression: "form.position"
    }
  }, [_vm._l(_vm.positionList, function (item, index) {
    return [_c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  })], 2)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.offset")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: !_vm.uploadImg
    },
    on: {
      blur: _vm.changePicOffset
    },
    model: {
      value: _vm.form.offset,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "offset", $$v);
      },
      expression: "form.offset"
    }
  })], 1)], 1) : _c("div", [_c("a-form-model-item", {
    key: "content",
    attrs: {
      label: _vm.$t("picWatermark.content"),
      prop: "content"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("picWatermark.placeholder")
    },
    on: {
      blur: _vm.changeTextContent
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.font")
    }
  }, [_c("a-select", {
    on: {
      change: _vm.changeTextFont
    },
    model: {
      value: _vm.form.font,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "font", $$v);
      },
      expression: "form.font"
    }
  }, [_vm._l(_vm.fontList, function (item, index) {
    return [_c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  })], 2)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.fontSize"),
      prop: "fontSize"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      blur: _vm.changeTextFontsize
    },
    model: {
      value: _vm.form.fontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fontSize", $$v);
      },
      expression: "form.fontSize"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.fontType")
    }
  }, [_c("a-select", {
    on: {
      change: _vm.changeTextStyle
    },
    model: {
      value: _vm.form.waterMarkFontStyle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "waterMarkFontStyle", $$v);
      },
      expression: "form.waterMarkFontStyle"
    }
  }, [_vm._l(_vm.fontType, function (item, index) {
    return [_c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  })], 2)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.color")
    }
  }, [_c("a-popover", {
    attrs: {
      trigger: "click"
    },
    model: {
      value: _vm.visibleColor,
      callback: function callback($$v) {
        _vm.visibleColor = $$v;
      },
      expression: "visibleColor"
    }
  }, [_c("span", {
    attrs: {
      slot: "content"
    },
    on: {
      click: function click() {
        return _vm.visibleColor = !_vm.visibleColor;
      }
    },
    slot: "content"
  }, [_c("sketch-picker", {
    on: {
      input: _vm.handleUpdate
    },
    model: {
      value: _vm.color,
      callback: function callback($$v) {
        _vm.color = $$v;
      },
      expression: "color"
    }
  })], 1), _c("div", {
    staticClass: "color",
    style: {
      "background-color": _vm.form.fontColor
    }
  })])], 1), _c("a-form-model-item", [_c("a-select", {
    on: {
      change: _vm.changeTextPosition
    },
    model: {
      value: _vm.form.textPosition,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "textPosition", $$v);
      },
      expression: "form.textPosition"
    }
  }, [_vm._l(_vm.textPosition, function (item, index) {
    return [_c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  })], 2)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.offsetW")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      blur: _vm.changeTextOffsetW
    },
    model: {
      value: _vm.form.xOffset,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "xOffset", $$v);
      },
      expression: "form.xOffset"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.offsetH")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    on: {
      blur: _vm.changeTextOffsetH
    },
    model: {
      value: _vm.form.yOffset,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "yOffset", $$v);
      },
      expression: "form.yOffset"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.transparency")
    }
  }, [_c("a-select", {
    on: {
      change: _vm.changeTextTransparency
    },
    model: {
      value: _vm.form.alpha,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "alpha", $$v);
      },
      expression: "form.alpha"
    }
  }, [_vm._l(_vm.transparencyList, function (item, index) {
    return [_c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  })], 2)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("picWatermark.rotate")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      max: 360,
      min: -360,
      placeholder: _vm.$t("picWatermark.placeholder")
    },
    on: {
      blur: _vm.changeTextRotate
    },
    model: {
      value: _vm.form.rotation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rotation", $$v);
      },
      expression: "form.rotation"
    }
  })], 1)], 1)], 1)], 1), _c("a-col", {
    staticClass: "right",
    attrs: {
      span: 8
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("picWatermark.previewPic")))]), _vm.previewImg ? _c("img", {
    staticStyle: {
      width: "300px",
      height: "300px",
      border: "1px solid #cccc"
    },
    attrs: {
      src: _vm.previewImg,
      alt: "#"
    }
  }) : _c("div", {
    staticClass: "empty"
  }, [_c("img", {
    attrs: {
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==",
      alt: ""
    }
  })])])], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };